var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("Приглашения сотрудников ("+_vm._s(_vm.regionteam.region_team_invites.length)+" из 10)")])
}
var staticRenderFns = []

export { render, staticRenderFns }